import noticeError from "./notice-error";

export async function fetchDraw(requestHelper, drawId, endpoint) {
  try {
    const response = await requestHelper.get({
      url: `/api/commerce/limiteddrops/v1/draws/${drawId}/${endpoint}`,
    });

    return response.data;
  } catch (error) {
    noticeError(error);
  }
}
